import React from 'react'

const LoaderSpin = ({classes}) => {
  return (
    <div className={`spin-wrap ${classes}`}> <span className={`loader`} ></span> </div>
  )
}

export default LoaderSpin